import BFFAPI from './utils/BFFAPI';

class DataExportsAPI extends BFFAPI {
  getDataExports = () => {
    const req = this.fetchHelper.createGetRequest(this.endpoint);
    return this.fetch(req);
  };

  exportMachineUsage = (from: string, to: string) => {
    const req = this.fetchHelper.createPostRequest(
      `${this.endpoint}/machine-usage`,
      { from, to }
    );
    return this.fetch(req);
  };

  exportRoboticMowerUsage = (from: string, to: string) => {
    const req = this.fetchHelper.createPostRequest(
      `${this.endpoint}/roboticmower-usage`,
      { from, to }
    );
    return this.fetch(req);
  };

  exportMaintenanceAndRepair = () => {
    const req = this.fetchHelper.createPostRequest(
      `${this.endpoint}/maintenance-repair`
    );
    return this.fetch(req);
  };

  exportMachinesAndInventory = () => {
    const req = this.fetchHelper.createPostRequest(
      `${this.endpoint}/inventory`
    );
    return this.fetch(req);
  };

  getExportStatus = (id: string) => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}/${id}`);
    return this.fetch(req);
  };

  getExportDownloadUrl = (id: string): Promise<{ url: string }> => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/${id}/download`
    );
    return this.fetch(req);
  };
}

export default new DataExportsAPI('/fleet/secure/exports');
